import { render, staticRenderFns } from "./PasswordForgotten.vue?vue&type=template&id=7aa8413e&scoped=true"
import script from "./PasswordForgotten.vue?vue&type=script&lang=ts"
export * from "./PasswordForgotten.vue?vue&type=script&lang=ts"
import style0 from "./PasswordForgotten.vue?vue&type=style&index=0&id=7aa8413e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aa8413e",
  null
  
)

export default component.exports